import * as actionTypes from 'actions/actionTypes';

const initialSideBarMenu = [
  {
    index: 1,
    title: 'Restaurants',
    class: 'sprite restaurant',
    active: true,
    restaurants: { businessDelivery: [], businessCollection: [] },
  },
  { index: 2, title: 'Fast Re-order', class: 'sprite reload', active: false },
  { index: 3, title: 'Vouchers', class: 'sprite voucher', active: false },
  {
    index: 4,
    title: 'Platters',
    class: 'sprite platters',
    active: false,
    restaurants: { businessPlatter: [] },
  },
  { index: 5, title: 'Cart', class: 'sprite cart', active: false },
  {
    index: 6,
    title: 'Delivery Tracking',
    class: 'sprite tracking',
    active: false,
  },
  { index: 7, title: 'Settings', class: 'sprite settings', active: false },
  { index: 8, title: 'GDPR Info', class: 'sprite gdpr', active: false },
  { index: 9, title: 'Logout', class: 'sprite logout', active: false },
];

const initialState = {
  titleHeader: 'Popular Dishes',
  showCollectionOption: false,
  loadingRecentlyOrder: false,
  addresses: [],
  listAddress: [],
  popularDishDelivery: [],
  recentlyOrdered: [],
  restaurantSelected: null,
  categoriesRestaurant: [],
  products: [],
  productSelected: null,
  itemsSideBarMenu: [...initialSideBarMenu],
  restaurantsOptions: [
    { id: 1, active: true, type: 'Delivery' },
    { id: 2, active: false, type: 'Collection' },
  ],
  showMenuMobile: false,
  showRestaurantsMobile: false,
  errorHandling: { showError: false, errorMessage: '' },
  acceptDeliverAtHome: false
}

const menuReducer = (state = initialState, actions) => {

  switch (actions.type) {
    case actionTypes.CHANGE_RESTAURANT_OPTIONS:
      let restaurantsOptions = state.restaurantsOptions.map(option => {
        if (option.id === actions.idRestaurantsOptions) {
          return { id: option.id, active: true, type: option.type };
        } else {
          return { id: option.id, active: false, type: option.type };
        }
      });
      return {
        ...state,
        restaurantsOptions: restaurantsOptions,
        categoriesRestaurant: [],
        products: [],
      };
    case actionTypes.MENU_FETCHING_ADDRESS_SUCCESS:
      return {
        ...state,
        listAddress: actions.listAddressToDelivery.filter( item => item.idBusinessAddress != null ||  item.idCustomerDeliveryAddress != null),
        acceptDeliverAtHome: actions.listAddressToDelivery.filter( item => item.idBusinessAddress === null && item.acceptDeliverAtHome === true).length > 0,
      }
    case actionTypes.MENU_SELECT_ADDRESS_FOR_ORDER:
      return {
        ...state,
        addresses: actions.address,
      };
    case actionTypes.LOGOUT:
      return {
        ...state,
        listAddress: [],
        addresses: [],
        showCollectionOption: false,
        titleHeader: 'Popular Dishes',
        restaurantSelected: null,
        restaurantsOptions: [
          { id: 1, active: true, type: 'Delivery' },
          { id: 2, active: false, type: 'Collection' },
        ],
        itemsSideBarMenu: [
          {
            index: 1,
            title: 'Restaurants',
            class: 'sprite restaurant',
            active: true,
            restaurants: { businessDelivery: [], businessCollection: [] },
          },
          {
            index: 2,
            title: 'Fast Re-order',
            class: 'sprite reload',
            active: false,
          },
          {
            index: 3,
            title: 'Team Vouchers',
            class: 'sprite voucher',
            active: false,
          },
          {
            index: 4,
            title: 'Platters',
            class: 'sprite platters',
            active: false,
            restaurants: { businessPlatter: [] },
          },
          { index: 5, title: 'Cart', class: 'sprite cart', active: false },
          {
            index: 6,
            title: 'Delivery Tracking',
            class: 'sprite tracking',
            active: false,
          },
          {
            index: 7,
            title: 'Settings',
            class: 'sprite settings',
            active: false,
          },
          
          { index: 8, title: 'GDPR Info', class: 'sprite gdpr', active: false },
          { index: 9, title: 'Logout', class: 'sprite logout', active: false },
        ],
      };
    case actionTypes.FETCHING_MENU_SUCCESS:

      let popularDishDelivery = !actions.popularDishDelivery
        ? [] 
        : actions.popularDishDelivery.map(item => {
        return {
          product: item.product,
          business: {
            ...item.business,
          },
        };
      });

      let itemsSideBarMenu = [...state.itemsSideBarMenu];
      itemsSideBarMenu[0].restaurants.businessDelivery =
        actions.businessDelivery;

      itemsSideBarMenu[0].restaurants.businessCollection =
        actions.businessCollection;
      itemsSideBarMenu[3].restaurants.businessPlatter = actions.businessPlatter;
      let showCollectionOption =
        actions.businessCollection.length > 0 &&
        state.listAddress.some(item => item.forCollection)
          ? true
          : false;
      return {
        ...state,
        itemsSideBarMenu: itemsSideBarMenu,
        popularDishDelivery: popularDishDelivery,
        showCollectionOption: showCollectionOption,
        titleHeader: 'Popular Dishes',
        restaurantSelected: null,
        restaurantsOptions: [
          { id: 1, active: true, type: 'Delivery' },
          { id: 2, active: false, type: 'Collection' },
        ],
        categoriesRestaurant: [
          { id: 0, name: "Popular Dishes", active: true },
          { id: 1, name: "Recently Ordered", active: false }
        ]
      };
    case actionTypes.SELECT_ITEM_SIDE_BAR_MENU:
      let itemsSideBarMenuUpdate = [...actions.itemsSideBar];
      return {
        ...state,
        itemsSideBarMenu: itemsSideBarMenuUpdate,
      };
    case actionTypes.MENU_RESTAURANT_VERIFY_AVAILABLE_SUCCESSFUL:
      let restaurantSelected = {
        ...state.restaurantSelected,
        isAvailable: actions.payload.isAvailable,
      };
      return {
        ...state,
        restaurantSelected: restaurantSelected,
      };
    case actionTypes.MENU_REMOVE_RESTAURANT_NOT_AVAILABLE:
      return {
        ...state,
        restaurantSelected: null,
      };
    case actionTypes.MENU_CHANGE_TITLE_HEADER:
      return {
        ...state,
        titleHeader: actions.titleHeader,
      };
    case actionTypes.CATEGORIES_SELECTED:
      let categoriesRestaurantUpdate = actions.categoriesRestaurant.map(
        categorie => {
          categorie.active = false;
          return categorie;
        }
      );
      return {
        ...state,
        categoriesRestaurant: categoriesRestaurantUpdate,
        products: [],
      };
    case actionTypes.RESTAURANT_SELECTED:
      return {
        ...state,
        restaurantSelected: actions.restaurant,
      };
    case actionTypes.SETTING_ACTIVE_CATEGORY:
      let categoriesRestaurantActiveUpdate = state.categoriesRestaurant.map(
        categorie => {
          if (categorie.id === actions.idActiveCategory) {
            categorie.active = true;
          } else {
            categorie.active = false;
          }
          return categorie;
        }
      );
      return {
        ...state,
        categoriesRestaurant: categoriesRestaurantActiveUpdate,
      };
    case actionTypes.DELETE_RESTAURANT_SELECTED:
      return {
        ...state,
        restaurantSelected: null,
      };
    case actionTypes.FETCHING_PRODUCT_SUCCESS:
      let productsUpdatedCurrency = actions.products.length > 0 ? actions.products.map(product => {
        product.currency = state.restaurantSelected.currency; 
        return product;
      }) : state.products;
      return {
        ...state,
        products: productsUpdatedCurrency,
      };
    case actionTypes.SELECT_PRODUCT:
      return {
        ...state,
        productSelected: actions.productSelected,
      };
    case actionTypes.CLOSE_PRODUCT_DETAILS:
      return {
        ...state,
        productSelected: null,
      };
    case actionTypes.FETCHING_RECENTLY_ORDERED_SUCCESS:
      return {
        ...state,
        recentlyOrdered: actions.recentlyOrdered,
      };
    case actionTypes.START_RECENTLY_ORDER_REQUEST:
      return {
        ...state,
        loadingRecentlyOrder: true,
      };
    case actionTypes.FINISH_RECENTLY_ORDER_REQUEST:
      return {
        ...state,
        loadingRecentlyOrder: false,
      };
    case actionTypes.MENU_RESET_STATE:
      return {
        ...state,
        restaurantSelected: null,
      };
    case actionTypes.TOGGLE_MENU_MOBILE:
      return {
        ...state,
        showMenuMobile: state.showRestaurantsMobile
          ? false
          : actions.status !== null
          ? actions.status
          : !state.showMenuMobile,
        showRestaurantsMobile: false,
      };
    case actionTypes.TOGGLE_RESTAURANTS_MOBILE:
      return {
        ...state,
        showMenuMobile: false,
        showRestaurantsMobile:
          actions.status !== null
            ? actions.status
            : !state.showRestaurantsMobile,
      };
    case actionTypes.MENU_ERROR_HANDLING:
      return {
        ...state,
        errorHandling: actions.errorHandling
      }
    case actionTypes.CREATED_NEW_CUSTOMER_DELIVERY_ADDRESS:
      return {
        ...state,
        addresses: [actions.payload],
        listAddress: state.listAddress.concat(actions.payload)
      }
    default:
      return state;
  }
};

export default menuReducer;



// WEBPACK FOOTER //
// ./src/store/reducers/menuReducer.js